import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobTicketsCard } from '@/features/jobs/details/components/JobTicketsCard'

export interface JobTicketsCardContainerProps {
  vm: JobDetailsViewModel
}

export const JobTicketsCardContainer = observer(
  function JobTicketsCardContainer({ vm }: JobTicketsCardContainerProps) {
    const ticket = vm.jobTicketsVm.latestTicket
    if (!ticket) {
      return null
    }

    return (
      <JobTicketsCard
        statusMessage={ticket.statusMessage}
        lastUpdated={ticket.lastUpdated}
      />
    )
  },
)
